import { useEffect, useRef, useState } from "react";
import video from "../assets/onboarding-background.mp4";
import RightColImageMap from "../assets/right-col-image-map.jpg";
import RightColImage from "../assets/right-col-image.jpg";
import { useMainContext } from "../context/MainContext.tsx";
import { nonSpectreJourney } from '../utils/backgroundImage.ts';

declare global {
  interface Navigator {
    connection?: NetworkInformation;
    mozConnection?: NetworkInformation;
    webkitConnection?: NetworkInformation;
  }

  interface NetworkInformation {
    effectiveType?: string;
    downlink?: number;
  }
}

const connection =
  navigator.connection || navigator.mozConnection || navigator.webkitConnection;



function BackgroundImage() {
  const ref = useRef<HTMLElement | null>(null);
  const { journeyId } = useMainContext();
  const backgroundImage = nonSpectreJourney(journeyId) ? RightColImageMap : RightColImage;
  /**
   * Mark displaying the video as not allowed until we determine that the connection demands are met
   * and that the element is actually visible
   */
  const [isVideoAllowed, setIsVideoAllowed] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const meetsConnectionDemands =
      connection?.effectiveType === "4g" &&
      connection?.downlink &&
      connection?.downlink > 1.5;

    let observer: ResizeObserver;
    if (ref.current && meetsConnectionDemands) {
      const element: HTMLElement = ref.current as HTMLElement;

      observer = new ResizeObserver(() => {
        if (!isVideoAllowed && ref.current?.parentElement) {
          const parentStyles = window.getComputedStyle(
            ref.current.parentElement,
          );
          setIsVideoAllowed(parentStyles.display !== "none");
        }
      });

      observer.observe(element);
    }

    return () => observer?.disconnect();
  }, [isVideoAllowed]);

  return (
    <div className="h-screen" ref={(r) => (ref.current = r)}>
      {isVideoAllowed && (journeyId === "spectre" || journeyId === "spectreretail") ? (
        <video autoPlay muted loop className="w-full h-full object-cover">
          <source src={video} type="video/mp4" />
          Sorry, your browser doesn't support video.
        </video>
      ) : (
        <img
          src={backgroundImage}
          alt=""
          draggable="false"
          className="w-full h-full object-cover"
        />
      )}
    </div>
  );
}

export default BackgroundImage;
